import { transactionStatusWithReasonLocalized } from "../../intl/shared-resources/transactionStatusWithReason.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import "../../components/icons/Icon.js";
import "react";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
const defaultChipMapping = {
  chipType: ChipType.Status,
  chipVariant: ChipVariant.Orange,
  startIconClass: CustomIcon.WarningOutline
};
const getTransactionStatusWithReasonChipConfig = () => ({
  "OnHoldRisk.UnderInvestigation": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.UnderInvestigation"],
    ...defaultChipMapping
  },
  "OnHoldRisk.Threshold24hrs": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.Threshold24hrs"],
    ...defaultChipMapping
  },
  "OnHoldRisk.KYCPending": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.KYCPending"],
    ...defaultChipMapping
  },
  "OnHoldRisk.PSPNoFunds": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.PSPNoFunds"],
    ...defaultChipMapping
  },
  "OnHoldRisk.GameplayReview": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.GameplayReview"],
    ...defaultChipMapping
  },
  "OnHoldRisk.MgmtReview": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.MgmtReview"],
    ...defaultChipMapping
  },
  "OnHoldRisk.Other": {
    label: transactionStatusWithReasonLocalized["OnHoldRisk.Other"],
    ...defaultChipMapping
  },
  "OnHoldPayment.UnderInvestigation": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.UnderInvestigation"],
    ...defaultChipMapping
  },
  "OnHoldPayment.Threshold24hrs": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.Threshold24hrs"],
    ...defaultChipMapping
  },
  "OnHoldPayment.KYCPending": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.KYCPending"],
    ...defaultChipMapping
  },
  "OnHoldPayment.PSPNoFunds": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.PSPNoFunds"],
    ...defaultChipMapping
  },
  "OnHoldPayment.GameplayReview": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.GameplayReview"],
    ...defaultChipMapping
  },
  "OnHoldPayment.MgmtReview": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.MgmtReview"],
    ...defaultChipMapping
  },
  "OnHoldPayment.Other": {
    label: transactionStatusWithReasonLocalized["OnHoldPayment.Other"],
    ...defaultChipMapping
  }
});
export {
  getTransactionStatusWithReasonChipConfig
};
//# sourceMappingURL=transactionStatusWithReasonChipConfig.js.map
